import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { ISavings } from '@vp/vp-js-token-engine';

export default class YouSaved extends React.Component<IPricePresentationBase<ISavings>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="youSaved"
        pricingInfo={this.props.pricingInfo}
        placeHolderText={this.props.placeHolderText}
      />
    );
  }
}
